import React from 'react';

import { Typography } from '@occc-app/design-system';
import { ConstraintRequiresActivationFragment } from '@occc/graphql';

interface IRequiresActivationProps {
  mustFulfillWithinDays?: ConstraintRequiresActivationFragment['mustFulfillWithinDays'];
}

export const RequiresActivation: React.FC<IRequiresActivationProps> = ({
  mustFulfillWithinDays,
}) => {
  return (
    <>
      <Typography variant='body2' gutterBottom>
        Activation Constraint
      </Typography>
      <Typography>
        {mustFulfillWithinDays
          ? `Offer activation is required and must be fulfilled within ${mustFulfillWithinDays} days`
          : 'Offer activation is required'}
      </Typography>
    </>
  );
};
